<template>
    <v-container fluid fill-height>
      <v-layout>
        <v-flex xs12 sm12 md12>
          <v-card :loading="loading">
            <v-toolbar color="#f8f9fb" elevation="0">
              <v-toolbar-title>{{ feedbacks.title }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
  
            <v-card-text class="#f4f5f7">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <ckeditor
                      v-html="editorData"
                      ></ckeditor>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
           
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </template>
  
  <script>

  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
  
  export default {
    data() {
      return {
        editor: ClassicEditor,
        feedbacks: [],
      };
    },
  
    methods: {
      getData() {
        let _self = this;
        _self.$axios
          .get("/cms?identifier=privacy_policy")
          .then((response) => {
            _self.feedbacks = response.data[0];
            _self.editorData = _self.feedbacks.content;
          });
      },
    },
    mounted() {
      this.getData();
    },
  };
  </script>
  